/** Kenya National ID: 8 or 9 digits */
export const NATIONAL_ID_MAX_DIGITS = 9;

export function normalizeNationalId(id) {
  return String(id || '').replace(/\D/g, '').slice(0, NATIONAL_ID_MAX_DIGITS);
}

export function validateNationalId(id) {
  const raw = String(id || '').replace(/\D/g, '');
  if (!/^\d{8,9}$/.test(raw)) {
    return { valid: false, message: 'National ID must be 8 or 9 digits' };
  }
  return { valid: true, normalized: raw };
}

/** KRA PIN: letter (A/P) + 9 digits + trailing letter, e.g. A012345678Z */
export function validateKraPin(pin) {
  const raw = String(pin || '').replace(/\s/g, '').toUpperCase();
  if (!/^[AP]\d{9}[A-Z]$/.test(raw)) {
    return { valid: false, message: 'Enter a valid KRA PIN (e.g. A012345678Z)' };
  }
  return { valid: true, normalized: raw };
}

/** Normalize Kenyan mobile to 07XXXXXXXX or 01XXXXXXXX */
export function normalizeKenyaMobile(phone) {
  let digits = String(phone || '').replace(/\s/g, '').replace(/^\+/, '');
  digits = digits.replace(/\D/g, '');
  if (!digits) return '';

  if (digits.startsWith('254')) {
    const national = digits.slice(3);
    if (national.length >= 9) {
      return `0${national.slice(0, 9)}`;
    }
  }

  if (digits.startsWith('0') && digits.length >= 10) {
    return digits.slice(0, 10);
  }

  if ((digits.startsWith('7') || digits.startsWith('1')) && digits.length >= 9) {
    return `0${digits.slice(0, 9)}`;
  }

  return digits.slice(0, 10);
}

export function validatePhone(phone) {
  const normalized = normalizeKenyaMobile(phone);
  if (!/^0[17]\d{8}$/.test(normalized)) {
    return {
      valid: false,
      message: 'Enter a valid Kenyan mobile number (e.g. 0712345678 or 0112345678)',
    };
  }
  return { valid: true, normalized };
}

export function validateEmail(email) {
  const raw = String(email || '').trim();
  if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(raw)) {
    return { valid: false, message: 'Enter a valid email address' };
  }
  return { valid: true, normalized: raw };
}
